import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {CreateApplicationDialogData} from '../../home/home.component';
import {CommonModule} from '@angular/common';
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {CatalogResource, CatalogsService} from "../../core/modules/openapi";
import {CommonService} from "../../services/common.service";

@Component({
  selector: 'app-create-application',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    CommonModule,
    MatOptionModule,
    MatSelectModule,
    MatDialogTitle
  ],
  templateUrl: './create-application.component.html',
  standalone: true,
  styleUrl: './create-application.component.sass'
})
export class CreateApplicationComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<CreateApplicationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateApplicationDialogData,
    private readonly formBuilder: FormBuilder, private readonly commonService: CommonService
  ) {
  }

  form: FormGroup;
  insurers: CatalogResource[];

  ngOnInit() {
    this.commonService.getInsurers().subscribe(insurers => {
      if (insurers) this.insurers = insurers;
    });
    this.form = this.formBuilder.group({
      insurer: [this.data.insurer, [Validators.required]],
      quotationID: [this.data.quotationID, [Validators.required, Validators.minLength(5), Validators.maxLength(50)]]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createClick(): void {
    this.form.controls['quotationID'].markAsTouched();
    this.form.controls['insurer'].markAsTouched();
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }
}
